var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLightModeIcon = function SvgLightModeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#LightModeIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.375 25.49c0 .482.394.875.875.875h3.5a.878.878 0 0 0 .875-.875v-.875h-5.25v.875ZM18 8.865a6.132 6.132 0 0 0-6.125 6.125 6.122 6.122 0 0 0 2.625 5.023v1.977c0 .482.394.875.875.875h5.25a.878.878 0 0 0 .875-.875v-1.977a6.122 6.122 0 0 0 2.625-5.023A6.132 6.132 0 0 0 18 8.865Zm2.494 9.713-.744.525v2.012h-3.5v-2.012l-.744-.525a4.372 4.372 0 0 1-1.881-3.588A4.377 4.377 0 0 1 18 10.615a4.377 4.377 0 0 1 4.375 4.375c0 1.426-.7 2.765-1.881 3.588Z",
    fill: "#45464F"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.938,
    y: 0.553,
    width: 34.125,
    height: 34.125,
    rx: 17.063,
    stroke: "#828695",
    strokeWidth: 0.875
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "LightModeIcon_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.115,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#fff"
  })))));
};
export default SvgLightModeIcon;